import React from "react";

interface SegmentedControlProps {
  selectedBgColor: string;
  selectedTextColor: string;
  numbersAsOptions: boolean;
  startNumber: number;
  unselectedBgColor: string;
  unselectedTextColor: string;
  hoverBgColor?: string;
  hoverTextColor?: string;
  options: string[];
  selected: number | string;
  setSelected: (value: number | string) => void;
  customClassNameOuterDiv: string;
  customClassNameInnerDiv: string;
  bold?: boolean;
}

export default function SegmentedControl({
  selectedBgColor,
  selectedTextColor,
  numbersAsOptions,
  startNumber,
  unselectedBgColor,
  unselectedTextColor,
  hoverBgColor = "",
  hoverTextColor = "",
  options,
  selected,
  setSelected,
  customClassNameOuterDiv,
  customClassNameInnerDiv,
  bold = true,
}: SegmentedControlProps) {
  const selectedColors = `${selectedBgColor} ${selectedTextColor}`;
  const unselectedColors = `${unselectedBgColor} ${unselectedTextColor}`;
  const hoverColors =
    hoverBgColor || hoverTextColor
      ? `${hoverBgColor || ""} ${hoverTextColor || ""}`.trim()
      : "hover:opacity-80";

  const renderOptions = options.map((option, index) => {
    index = index + startNumber;
    const preferredValueStructure = numbersAsOptions ? index : option;
    const isSelected = selected === preferredValueStructure;

    return (
      <div
        key={`segmented-control-option-${index}-${option}`}
        className={`w-full flex justify-center items-center select-none transition-all duration-150
        ${bold ? "font-semibold" : ""}
            ${
              isSelected ? selectedColors : `${unselectedColors} ${hoverColors}`
            } 
             ${customClassNameInnerDiv}`}
        onClick={() => setSelected(preferredValueStructure)}
      >
        <p>{option}</p>
      </div>
    );
  });
  return (
    <div
      className={`overflow-hidden cursor-pointer w-full flex ${customClassNameOuterDiv}`}
    >
      {renderOptions}
    </div>
  );
}

// Hella proudly made by ponta
